import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Formsy from 'formsy-react';
import { t } from 'i18next';
import React from 'react';

import MinimalSelectBox from '@sophocles/components/FormFields/MinimalSelectBox';
import MinimalTextBox from '@sophocles/components/FormFields/MinimalTextBox';

class IssueSubCategoryDialog extends React.Component {
  constructor(props) {
    super(props);
    const { issue, categories, nameError, issueCategory } = props;
    this.state = {
      obsolete: issue ? issue.get('obsolete', false) : false,
      canSubmit: true,
    };
  }

  _toggleObsolete = () => this.setState({ obsolete: !this.state.obsolete });

  handleClose = () => this.props.closeDialog();

  save = values => {
    const { save, issue } = this.props;
    const id = issue ? issue.get('id', 0) : 0;
    values.obsolete = this.state.obsolete;
    return save(id, values);
  };

  submitForm = () => this.form.submit();

  enableSaveButton = () => this.setState({ canSubmit: true });

  disableSaveButton = () => this.setState({ canSubmit: false });

  updateCategory = event => this.setState({ category: event.target.value });

  render() {
    const { open, issue, nameError, categories, issueCategory, edit, errors, clearErrors } = this.props;
    const { canSubmit, obsolete, category, name } = this.state;

    const actions = [
      <Button key="cancel" variant="outlined" onClick={this.handleClose}>
        {t('actions.cancel', 'Cancel')}
      </Button>,
      <Button key="submit" variant="contained" disabled={!canSubmit} onClick={this.submitForm}>
        {t('actions.submit', 'Submit')}
      </Button>,
    ];

    const dialogTitle = (edit ? 'Edit' : 'Add') + ' Issue';
    const editCheck = issue ? issue.getIn(['category', 'obsolete']) : issueCategory.get('obsolete');
    return (
      <Dialog open={open} onClose={this.handleClose}>
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent dividers>
          <Formsy
            ref={input => (this.form = input)}
            onSubmit={this.save}
            onValid={this.enableSaveButton}
            onInvalid={this.disableSaveButton}
          >
            <div style={{ fontSize: '14px' }}>
              {!editCheck ? (
                <div>
                  <label style={{ margin: 0 }}>
                    <input type="checkbox" checked={obsolete} onChange={this._toggleObsolete} /> Hidden
                  </label>
                  <div style={{ padding: '0 0 8px 8px', fontSize: '.8rem' }}>
                    Marking an issue hidden will prevent it from being visible to the support staff for future use.
                  </div>
                </div>
              ) : null}
              <div>
                <label style={{ margin: 0, fontWeight: 'bold' }}>Name</label>
                <MinimalTextBox
                  required
                  name="name"
                  value={issue ? issue.get('name', '') : ''}
                  inputProps={{ rows: 1, maxLength: 50 }}
                  maxLength="50"
                  id="textbox"
                />
              </div>
              <div style={{ color: 'var(--md-error)', padding: '8px 0' }}>{nameError}</div>
              <div>
                <label style={{ margin: 0, fontWeight: 'bold', display: 'block' }}>Category</label>
                <MinimalSelectBox
                  name="category_id"
                  value={issue ? issue.getIn(['category', 'id']) : issueCategory ? issueCategory.get('id') : 5}
                  style={{
                    border: '1px solid var(--border-default)',
                    borderRadius: 'var(--radius-md)',
                    background: 'transparent',
                  }}
                >
                  {categories.map(category => (
                    <option key={category} value={category.get('id')}>
                      {category.get('name')}
                    </option>
                  ))}
                </MinimalSelectBox>
              </div>
            </div>
          </Formsy>
        </DialogContent>
        <DialogActions>{actions}</DialogActions>
      </Dialog>
    );
  }
}
export default IssueSubCategoryDialog;
